import React, { useCallback } from 'react';

import { Company } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$types';
import { useCompany, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import {
	BaseModal,
	Box,
	Button,
	ComposedElement,
	Image,
	Overlay,
	Typography,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { Info, NavClose, Check } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { Lightning } from '@bcp-nextgen-dx-component-factory/icons-foundation';
import { useHideScroll, useIsVisibleModal, useModal } from '@hooks';

export const ShareYourSimulation: React.FC = () => {
	const { enable } = useHideScroll();
	const { colorPalette } = useTheme();
	const isVisible = useIsVisibleModal('shareYourSimulation');
	const { hide } = useModal('shareYourSimulation');
	const translate = useTranslation();
	const company = useCompany();

	const handleOnClickClose = useCallback(
		(action: 'continue' | 'notContinue') => {
			enable();
			hide(action);
		},
		[hide]
	);

	return (
		<BaseModal visible={isVisible} externalBackdrop={<Overlay onPress={() => handleOnClickClose('notContinue')} />}>
			<Box
				styles={{
					background: 'white',
					flexDirection: 'column',
					padding: '12px 0px 32px',
					maxWidth: '343px',
					borderRadius: '24px',
				}}
			>
				<Box
					onPress={() => handleOnClickClose('notContinue')}
					styles={{ justifyContent: 'flex-end', padding: '0 12px 0 0' }}
				>
					<Image
						source={NavClose.Outline}
						svgProps={{
							fill: '#6A717C',
							width: '24px',
							height: '24px',
						}}
					/>
				</Box>

				<Box styles={{ alignItems: 'center', flexDirection: 'column', padding: '0 32px' }}>
					{company === Company.bcp ? (
						<Box>
							<Box styles={{ border: `3px solid ${colorPalette.color_02[100]}`, borderRadius: '50px' }}>
								<ComposedElement
									icon={{
										source: Info.Outline,
										svgProps: { fill: colorPalette.color_02[100] },
									}}
									size="big"
								/>
							</Box>
						</Box>
					) : (
						<Box
							styles={{
								background: colorPalette.color_02[100],
								width: '64px',
								height: '64px',
								justifyContent: 'center',
								borderRadius: '32px',
								margin: '-64px 0 24px',
								border: '4px solid white',
							}}
						>
							<ComposedElement
								icon={{ source: Lightning.Outline, svgProps: { fill: 'white' } }}
								size="small"
							/>
						</Box>
					)}

					<Box styles={{ margin: '24px 0 32px' }}>
						<Typography appearance="subtitle-100-04" styles={{ textAlign: 'center' }}>
							{translate('simulator.modals.shareYourSimulation.title')}
						</Typography>
					</Box>

					<Box styles={{ flexDirection: 'column' }}>
						<Box styles={{ alignItems: 'center', columnGap: '4px', height: '4px' }}>
							<Box styles={{ width: '20px' }}>
								<Check />
							</Box>

							<Box>
								<Typography appearance="body-100-04">
									{translate('simulator.modals.shareYourSimulation.fin')}
								</Typography>
							</Box>
						</Box>
						<Box styles={{ alignItems: 'center', columnGap: '4px' }}>
							<Box styles={{ width: '20px' }}>
								<Check />
							</Box>

							<Box>
								<Typography appearance="body-100-04">
									{translate('simulator.modals.shareYourSimulation.draft')}
								</Typography>
							</Box>
						</Box>
					</Box>

					<Box styles={{ marginTop: '16px', width: '100%' }}>
						<Button fullWidth size="xLarge" onPress={() => handleOnClickClose('continue')}>
							{translate('simulator.modals.shareYourSimulation.button')}
						</Button>
					</Box>
				</Box>
			</Box>
		</BaseModal>
	);
};
